var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 34,
    viewBox: "0 0 67 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7402 1.70703H62.3743C63.3078 1.70842 64.2026 2.10107 64.8626 2.79888C65.5226 3.4967 65.894 4.44274 65.8954 5.42961C65.8961 5.63205 65.8795 5.83414 65.8457 6.03341L63.0448 24.1317C62.9102 25.0035 62.4865 25.7961 61.8495 26.3676C61.2125 26.9391 60.4038 27.2521 59.5684 27.2505H5.1934C4.26043 27.2505 3.36559 26.859 2.70541 26.1621C2.04523 25.4651 1.67368 24.5196 1.67236 23.5332V14.4656C1.67236 11.0818 2.9438 7.83665 5.20696 5.44394C7.47013 3.05124 10.5396 1.70703 13.7402 1.70703Z",
    fill: "white",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0993 32.3373C18.7707 32.3373 20.9364 30.0477 20.9364 27.2233C20.9364 24.399 18.7707 22.1094 16.0993 22.1094C13.4278 22.1094 11.2622 24.399 11.2622 27.2233C11.2622 30.0477 13.4278 32.3373 16.0993 32.3373Z",
    fill: "white",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1965 32.3373C30.8679 32.3373 33.0335 30.0477 33.0335 27.2233C33.0335 24.399 30.8679 22.1094 28.1965 22.1094C25.525 22.1094 23.3594 24.399 23.3594 27.2233C23.3594 30.0477 25.525 32.3373 28.1965 32.3373Z",
    fill: "white",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5829 6.5625H43.3038C42.8184 6.5625 42.4248 6.97857 42.4248 7.49183V21.4423C42.4248 21.9556 42.8184 22.3716 43.3038 22.3716H48.5829C49.0684 22.3716 49.4619 21.9556 49.4619 21.4423V7.49183C49.4619 6.97857 49.0684 6.5625 48.5829 6.5625Z",
    fill: "white",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5088 6.5625H11.9225C11.437 6.5625 11.0435 6.97857 11.0435 7.49183V12.1437C11.0435 12.657 11.437 13.0731 11.9225 13.0731H34.5088C34.9943 13.0731 35.3878 12.657 35.3878 12.1437V7.49183C35.3878 6.97857 34.9943 6.5625 34.5088 6.5625Z",
    fill: "white",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7724 27.2227H41.0933V32.3366H50.7724V27.2227Z",
    fill: "white",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.6731fca4123d2078b4d75f37bc0c0cbd.svg";
export { ForwardRef as ReactComponent };